import { render, staticRenderFns } from "./BusinessLocationPriceChangeRequestSlideover.vue?vue&type=template&id=beab4a12"
import script from "./BusinessLocationPriceChangeRequestSlideover.vue?vue&type=script&lang=js"
export * from "./BusinessLocationPriceChangeRequestSlideover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports